module.exports = __webpack_public_path__ + "img/symbol_9.cab06d61.png";